import { CreateMapping } from 'Store/common/common.types'
import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  ListReq,
  ListRes,
  DetailReq,
  DetailRes,
  CreateReq,
  ActionRes,
  UpdateReq,
  DeleteReq,
  MasterProductReq,
  ImportProductReq,
  RequestProductReq,
  UpdateRequestStatusReq,
  UpdateProductStatusReq,
  GetAllProductReq,
  UpdateProductPriceReq,
  UpdateProductPricRes,
  BomDetailReq,
  BomDetailRes,
  UpdateProductBomReq,
  UpdateProductBomRes,
  ImportFileProductCheckingReq,
  ImportFileProductCheckingRes,
  ImportFileProductReq,
  ImportFileProductRes,
  LogRes,
  ApproveListRes,
  ApproveDetailRes,
  ApproveDetailReq,
} from './types'

export const getListAction = createAsyncAction(
  'PRODUCT/GET_PRODUCT_LIST_REQ',
  'PRODUCT/GET_PRODUCT_LIST_SUCCESS',
  'PRODUCT/GET_PRODUCT_LIST_FAILURE',
)<ListReq, ListRes, Error>()

export const getDetailAction = createAsyncAction(
  'PRODUCT/GET_PRODUCT_DETAIL_REQ',
  'PRODUCT/GET_PRODUCT_DETAIL_SUCCESS',
  'PRODUCT/GET_PRODUCT_DETAIL_FAILURE',
)<DetailReq, DetailRes, Error>()

export const getBomDetailAction = createAsyncAction(
  'PRODUCT/GET_BOM_DETAIL_REQ',
  'PRODUCT/GET_BOM_DETAIL_SUCCESS',
  'PRODUCT/GET_BOM_DETAIL_FAILURE',
)<BomDetailReq, BomDetailRes, Error>()

export const createAction = createAsyncAction(
  'PRODUCT/CREATE_PRODUCT_REQ',
  'PRODUCT/CREATE_PRODUCT_SUCCESS',
  'PRODUCT/CREATE_PRODUCT_FAILURE',
)<CreateMapping<CreateReq>, ActionRes, Error>()

export const updateAction = createAsyncAction(
  'PRODUCT/UPDATE_PRODUCT_REQ',
  'PRODUCT/UPDATE_PRODUCT_SUCCESS',
  'PRODUCT/UPDATE_PRODUCT_FAILURE',
)<UpdateReq, ActionRes, Error>()

export const deleteAction = createAsyncAction(
  'PRODUCT/DELETE_PRODUCT_REQ',
  'PRODUCT/DELETE_PRODUCT_SUCCESS',
  'PRODUCT/DELETE_PRODUCT_FAILURE',
)<DeleteReq, ActionRes, Error>()

export const getMasterProductAction = createAsyncAction(
  'PRODUCT/GET_MASTER_PRODUCT_DETAIL_REQ',
  'PRODUCT/GET_MASTER_PRODUCT_DETAIL_SUCCESS',
  'PRODUCT/GET_MASTER_PRODUCT_DETAIL_FAILURE',
)<MasterProductReq, ListRes, Error>()

export const importProductAction = createAsyncAction(
  'PRODUCT/IMPORT_PRODUCT_DETAIL_REQ',
  'PRODUCT/IMPORT_PRODUCT_DETAIL_SUCCESS',
  'PRODUCT/IMPORT_PRODUCT_DETAIL_FAILURE',
)<ImportProductReq, ActionRes, Error>()

export const getRequestProductsAction = createAsyncAction(
  'PRODUCT/GET_PRODUCT_REQUEST_REQ',
  'PRODUCT/GET_PRODUCT_REQUEST_SUCCESS',
  'PRODUCT/GET_PRODUCT_REQUEST_FAILURE',
)<RequestProductReq, ApproveListRes, Error>()

export const updateRequestStatusAction = createAsyncAction(
  'PRODUCT/UPDATE_REQUEST_STATUS_REQ',
  'PRODUCT/UPDATE_REQUEST_STATUS_SUCCESS',
  'PRODUCT/UPDATE_REQUEST_STATUS_FAILURE',
)<UpdateRequestStatusReq, ActionRes, Error>()

export const updateProductStatusAction = createAsyncAction(
  'PRODUCT/UPDATE_PRODUCT_STATUS_REQ',
  'PRODUCT/UPDATE_PRODUCT_STATUS_SUCCESS',
  'PRODUCT/UPDATE_PRODUCT_STATUS_FAILURE',
)<UpdateProductStatusReq, ActionRes, Error>()

export const getAllProductListAction = createAsyncAction(
  'PRODUCT/GET_ALL_PRODUCT_LIST_REQ',
  'PRODUCT/GET_ALL_PRODUCT_LIST_SUCCESS',
  'PRODUCT/GET_ALL_PRODUCT_LIST_FAILURE',
)<GetAllProductReq, ListRes, Error>()

export const updateProductPriceAction = createAsyncAction(
  'PRODUCT/UPDATE_PRODUCT_PRICE_REQ',
  'PRODUCT/UPDATE_PRODUCT_PRICE_SUCCESS',
  'PRODUCT/UPDATE_PRODUCT_PRICE_FAILURE',
)<UpdateProductPriceReq, UpdateProductPricRes, Error>()

export const updateProductBomAction = createAsyncAction(
  'PRODUCT/UPDATE_PRODUCT_BOM_REQ',
  'PRODUCT/UPDATE_PRODUCT_BOM_SUCCESS',
  'PRODUCT/UPDATE_PRODUCT_BOM_FAILURE',
)<UpdateProductBomReq, UpdateProductBomRes, Error>()

export const checkingProductFromFileAction = createAsyncAction(
  'PRODUCT/CHECKING_PRODUCT_FILE_REQ',
  'PRODUCT/CHECKING_PRODUCT_FILE_SUCCESS',
  'PRODUCT/CHECKING_PRODUCT_FILE_FAILURE',
)<ImportFileProductCheckingReq, ImportFileProductCheckingRes, Error>()

export const createProductFromFileAction = createAsyncAction(
  'PRODUCT/CREATE_PRODUCT_FILE_REQ',
  'PRODUCT/CREATE_PRODUCT_FILE_SUCCESS',
  'PRODUCT/CREATE_PRODUCT_FILE_FAILURE',
)<ImportFileProductReq, ImportFileProductRes, Error>()

export const getLogRequestProductsAction = createAsyncAction(
  'PRODUCT/GET_LOG_PRODUCT_REQUEST_REQ',
  'PRODUCT/GET_LOG_PRODUCT_REQUEST_SUCCESS',
  'PRODUCT/GET_LOG_PRODUCT_REQUEST_FAILURE',
)<RequestProductReq, LogRes, Error>()

export const getApproveProductDetailAction = createAsyncAction(
  'PRODUCT/GET_DETAIL_PRODUCT_REQUEST_REQ',
  'PRODUCT/GET_DETAIL_PRODUCT_REQUEST_SUCCESS',
  'PRODUCT/GET_DETAIL_PRODUCT_REQUEST_FAILURE',
)<ApproveDetailReq, ApproveDetailRes, Error>()

export const clearEventAction = createStandardAction('PRODUCT/CLEAR_EVENT')<void>()

export const resetLastImportAction = createStandardAction('PRODUCT/RESET_LAST_IMPORT_EVENT')<void>()

export const clearChunkEventAction = createStandardAction('PRODUCT/CLEAR_CHUNK_EVENT')<void>()
